import { ValidatorFn, AbstractControl, ValidationErrors, FormGroup } from '@angular/forms';
import { BaseWeekDays, BaseInquiryShifts, BaseShiftPersonsEnum } from '../../modules/inquiry/_enums/base-inquiry.enum';
import { mapDaysOfWeekToNumbers } from '../helpers/base-day-object-to-array-converter';
import { getDaysArrayWithWeekdays } from '../helpers/base-get-dates-array-between-two-dates';
import {
  BaseStaffRequestFormDatesInterface,
  BaseStaffRequestFormInterface,
} from '../../modules/inquiry/_interfaces/base-inquiry.interface';
import { FormRawValue } from '../../modules/inquiry/_interfaces/base-form.interface';

export const atLeastOneWeekday = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    return oneWeekday(control) ? null : { invalidWeekdays: true };
  };
};

export const flexShiftsAmountValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const minFlexShiftsSelected =
      control.get(BaseInquiryShifts.FD)?.value +
        control.get(BaseInquiryShifts.ZD)?.value +
        control.get(BaseInquiryShifts.SD)?.value +
        control.get(BaseInquiryShifts.ND)?.value >=
      2;

    return minFlexShiftsSelected ? null : { invalidShifts: true };
  };
};

export const atLeastOnePerson = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const persons =
      control.get(BaseShiftPersonsEnum.fd)?.value +
        control.get(BaseShiftPersonsEnum.sd)?.value +
        control.get(BaseShiftPersonsEnum.nd)?.value +
        control.get(BaseShiftPersonsEnum.zd)?.value >=
      1;
    return persons ? null : { invalidShiftPersons: true };
  };
};

const oneWeekday = (control: AbstractControl) => {
  return (
    control.get(BaseWeekDays.MO)?.value +
      control.get(BaseWeekDays.TU)?.value +
      control.get(BaseWeekDays.WE)?.value +
      control.get(BaseWeekDays.TH)?.value +
      control.get(BaseWeekDays.FR)?.value +
      control.get(BaseWeekDays.SA)?.value +
      control.get(BaseWeekDays.SU)?.value >=
    1
  );
};

export const weekdayDateValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const { range, weekdays } = control.value as FormRawValue<FormGroup<BaseStaffRequestFormDatesInterface>>;

    const selectedWeekdays = mapDaysOfWeekToNumbers(weekdays);

    if (selectedWeekdays.length === 0) {
      return null;
    }

    const dates = getDaysArrayWithWeekdays<string>(new Date(range.from), new Date(range.to), selectedWeekdays);

    return dates.length === 0 ? { invalidSelectedDays: true } : null;
  };
};

export const dutyDataValidator = (): ValidatorFn => {
  return (control: AbstractControl): ValidationErrors | null => {
    const { shiftsAndPersons, dates, flexShift } = control.value as FormRawValue<
      FormGroup<BaseStaffRequestFormInterface>
    >;

    const isWeekdaySelected = Object.values(dates.weekdays).some((weekday) => weekday);

    if (flexShift) {
      const isAmountOfPersonsExist = shiftsAndPersons.amountPersons > 0;
      const selectedShiftsLength = Object.values(shiftsAndPersons.shifts).filter((shift) => !!shift).length;
      const requiredFieldsAreSelected = isWeekdaySelected && selectedShiftsLength >= 2 && isAmountOfPersonsExist;
      const allFieldsAreDeselected = !isWeekdaySelected && !selectedShiftsLength && !isAmountOfPersonsExist;

      if (requiredFieldsAreSelected || allFieldsAreDeselected) {
        return null;
      }

      return { invalidDutyData: true };
    }

    const isAnyPerson = Object.values(shiftsAndPersons.persons).some((person) => person > 0);
    if (isWeekdaySelected && isAnyPerson) {
      return null;
    }

    return { invalidDutyData: true };
  };
};
